import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataDateTime
} from "pbas-vue-components";

import { translate } from '../trans'
import store from '@/store'
import { i18n } from "@/plugins/i18n";
const ODataDependantsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataDate("MemberIdentityId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("Relationship/Name"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1
  // }),
  // new ODataHeader({
  //   type: new ODataString("Relationship/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("Relationship/Translations[]/DisplayValue", {
  //     getString: item => {
  //       if (!item) return "";
  //       const lang = store.getters['common/language']
  //       return translate(item.Relationship, lang.language);
  //     }
  //   }),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "Relationship/Name",
  //   version: 1
  // }),
  
  // new ODataHeader({
  //   title: "Relationship Id",
  //   type: new ODataString("Relationship/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "RelationshipId",
  //   type: new ODataString("RelationshipId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("Current/LastName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("Current/FirstName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.members_management.SIN",
    type: new ODataString("Current/SIN"),
    sortable: true,
  }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("Current/DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
const pensionDependantsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataDate("MemberIdentityId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("Relationship/Name"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1
  // }),
  // new ODataHeader({
  //   type: new ODataString("Relationship/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("Relationship/Translations[]/DisplayValue", {
  //     getString: item => {
  //       if (!item) return "";
  //       const lang = store.getters['common/language']
  //       return translate(item.Relationship, lang.language);
  //     }
  //   }),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "Relationship/Name",
  //   version: 1
  // }),
  
  // new ODataHeader({
  //   title: "Relationship Id",
  //   type: new ODataString("Relationship/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "RelationshipId",
  //   type: new ODataString("RelationshipId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    title: "headers.members_management.Membership Id",
    type: new ODataString("SelfMemberIdentity/MemberIdentification/PensionMembershipId"),
    sortable: true,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("Current/LastName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("Current/FirstName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.members_management.SIN",
    type: new ODataString("Current/SIN"),
    sortable: true,
  }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("Current/DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
function getDependantsHeaders(planType) {
  if (planType === "Pension") {
    return pensionDependantsHeaders;
  }
  return ODataDependantsHeaders;
}
export default getDependantsHeaders;